import { OFFER_BENEFITS, contactUpgradeHref } from './offersCopy';

function normalizeCommercialTier(tier) {
  const t = String(tier || 'INCLUS').toUpperCase();
  if (t === 'PLUS' || t === 'PREMIUM') return 'PLUS';
  return 'INCLUS';
}

/**
 * Comparatif Inclus / Plus — upgrade commercial, pas une grille de quotas.
 * Premium technique est présenté comme couvert par le niveau Plus côté discours V1.
 */
export default function CommunicationOffersModal({ isOpen, onClose, currentTier = 'INCLUS' }) {
  if (!isOpen) return null;

  const commercialCurrent = normalizeCommercialTier(currentTier);

  return (
    <div className="fixed inset-0 z-[6000] overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4 py-8">
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75" onClick={onClose} aria-hidden />
        <div className="relative bg-white rounded-lg shadow-xl w-full max-w-3xl overflow-hidden">
          <div className="px-6 py-4 border-b border-gray-100 flex items-center justify-between">
            <div>
              <h3 className="text-lg font-semibold text-gray-900">Découvrir les offres Communication</h3>
              <p className="text-sm text-gray-500 mt-0.5">
                Deux niveaux simples : communiquez, puis développez.
              </p>
            </div>
            <button type="button" className="text-sm text-gray-500 hover:text-gray-800" onClick={onClose}>
              Fermer
            </button>
          </div>

          <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-4">
            {['INCLUS', 'PLUS'].map((key) => {
              const offer = OFFER_BENEFITS[key];
              const isCurrent = commercialCurrent === key;
              const highlighted = key === 'PLUS';
              return (
                <div
                  key={key}
                  className={`rounded-lg border p-5 ${
                    highlighted ? 'border-primary-500 bg-primary-50/40' : 'border-gray-200 bg-white'
                  }`}
                >
                  <div className="flex items-center justify-between gap-2">
                    <p className="text-xl font-semibold text-gray-900">{offer.label}</p>
                    {isCurrent && (
                      <span
                        className={`text-xs font-medium px-2 py-0.5 rounded ${
                          highlighted
                            ? 'bg-primary-100 text-primary-800'
                            : 'bg-gray-100 text-gray-700'
                        }`}
                      >
                        Offre actuelle
                      </span>
                    )}
                  </div>
                  <p className="mt-1 text-sm text-gray-600">{offer.tagline}</p>
                  <ul className="mt-4 space-y-2 text-sm text-gray-700">
                    {offer.bullets.map((b) => (
                      <li key={b} className="flex gap-2">
                        <span className="text-primary-600 mt-0.5">✓</span>
                        <span>{b}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              );
            })}
          </div>

          <div className="px-6 pb-6 flex flex-wrap items-center justify-between gap-3">
            <p className="text-xs text-gray-500 max-w-md">
              Clickorico active l’offre Plus sur votre commerce. Écrivez-nous pour évoluer.
            </p>
            <div className="flex gap-2">
              <button type="button" className="btn-secondary" onClick={onClose}>
                Fermer
              </button>
              <a href={contactUpgradeHref()} className="btn-primary inline-flex items-center">
                Contacter Clickorico
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
